module.exports = __webpack_public_path__ + "img/icon7.d31e760e.png";